import { render } from "./FooterPages.vue?vue&type=template&id=15246e7a"
import script from "./FooterPages.vue?vue&type=script&lang=js"
export * from "./FooterPages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__